import { render, staticRenderFns } from "./LightPackageShipmentForm.vue?vue&type=template&id=b225eee4&scoped=true"
import script from "./LightPackageShipmentForm.vue?vue&type=script&lang=js"
export * from "./LightPackageShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./LightPackageShipmentForm.vue?vue&type=style&index=0&id=b225eee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b225eee4",
  null
  
)

export default component.exports